// extracted by mini-css-extract-plugin
module.exports = {"emailTabMinimized":"az_cOb","emailTabMinimizedContent":"az_dOb","promoToggle":"az_eOb","promoText":"az_fOb","chevronIcon":"az_gOb","rotateToggle":"az_hOb"};